/**
 * Translate the given key.
 */
window.trans = function(key, replaces) {
    let locale = document.documentElement.getAttribute('lang');
    let translation = key;

    // Check if present in DB
    if (window.translations && window.translations[translation]) {
        translation = window.translations[translation];
        translation = transReplaces(translation, replaces);
        return translation;
    }

    // If not, then check if english and skip if it is
    if (locale == 'en') {
        translation = transReplaces(translation, replaces);
        return translation;
    }

    // Or try to fetch the translation from the language files
    try {
        const translations = require(`@lang/${locale}.json`);
        translation = translations[key] ? translations[key] : key;

        translation = transReplaces(translation, replaces);
    } catch (error) {
        if (process.env.NODE_ENV !== 'production') {
            console.error(error);
        }
    }

    return translation;
}

// Simple choice variant (single/plural only, no advanced count etc.)
window.trans_choice = function(key, count = 1, replaces) {
    let translation = trans(key, replaces);
    const [single, plural] = translation.split('|');

    return count > 1 ? plural : single;
}

// Replace keys in translation
function transReplaces(text, replaces) {
    for (var key in replaces) {
        text = text.replace(':' + key, replaces[key])
    }

    return text;
}